import { render, staticRenderFns } from "./NbaLayout.vue?vue&type=template&id=4159d238&scoped=true"
import script from "./NbaLayout.vue?vue&type=script&lang=js"
export * from "./NbaLayout.vue?vue&type=script&lang=js"
import style0 from "./NbaLayout.vue?vue&type=style&index=0&id=4159d238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159d238",
  null
  
)

export default component.exports